var React = require('react');

function IconYoutube (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"youtube"),React.createElement("path",{"d":"M74,37.89a6.28,6.28,0,0,0-4.43-4.45c-3.89-1-19.53-1-19.53-1s-15.64,0-19.53,1A6.28,6.28,0,0,0,26,37.89C25,41.81,25,50,25,50s0,8.19,1,12.11a6.28,6.28,0,0,0,4.43,4.45c3.89,1,19.53,1,19.53,1s15.64,0,19.53-1A6.28,6.28,0,0,0,74,62.11C75,58.19,75,50,75,50S75,41.81,74,37.89ZM44.89,57.43V42.57L58,50Z","key":1})]);
}

IconYoutube.displayName = "IconYoutube";

IconYoutube.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = IconYoutube;

IconYoutube.default = IconYoutube;
